export default __webpack_public_path__ + "static/media/icon_sgtech.c48e1482.webp";